import React from 'react';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { AvailabilityDowntimeGlobalWithError } from '../../../Online/components/Availability/AvailabilityDowntimeGlobalWithError';

export const AvailabilityDowntimeGlobalWithErrorChart = React.memo(
  ({ objetivoId }) => {
    const { filterPeriod, refreshTime } = useDynamicViewState();
    return (
      <AvailabilityDowntimeGlobalWithError
        objetivoId={objetivoId}
        statePeriod={filterPeriod.statePeriod}
        refreshTime={refreshTime}
        period={filterPeriod.period}
      />
    );
  },
);
